//import Fetching from '@/services/FetchData';
let getApi = () => import('@/services/Api');
import moment from 'moment';

const state = {
    errorText: [],
    langs: sessionStorage.getItem('languageList') ? JSON.parse(sessionStorage.getItem('languageList')) : [],
    translations: sessionStorage.getItem('translationList') ? JSON.parse(sessionStorage.getItem('translationList')) : [],
    progressBar: '',
    routeName: '',
    routeParams: null,
    statusColor: {
        RETURN: 'success',
        ASSIGN: 'primary',
        REASSIGN: 'info',
        LOST: 'error',
        LOSTFOUND: 'error',
        CHECK: 'info',
        CHECKRETURN: 'success',
        TRANSIT: 'info',
        TRANSITARRIVE: 'success',
        OVERDUE: 'error',
        PROMISE: 'warning',
        SLEEPMODEON: 'lime',
        SLEEPMODEOFF: 'success',
        DAMAGED: 'error',
        RESTORED: 'success',
    },
    theNavBarDrawer: false,
    appDistributionPoint: null,
    distributionPointCatalog: [],
    calendarKey: 0,
    needToUpdateAllDashboards: 0,
};


// getters
const getters = {
    getErrorText: state => state.errorText,
    getProgress: state => state.progressBar,
    getLangs: state => state.langs,
    getTranslation: (state, getters) => (def, code, entity, toDialog) => {
        if (!code) return def;
        let fullKey = `${(entity) ? entity : ''}${code}${getters.getChosenLang}`;
        let defKey = `${code}${getters.getChosenLang}`;
        let defOnForm = (toDialog) ? `labelOnDialog_${code}${getters.getChosenLang}` : '';
        return state.translations[defOnForm.toUpperCase()] || state.translations[fullKey.toUpperCase()] || state.translations[defKey.toUpperCase()] || def
    },
    getRouteName: (state) => state.routeName,
    getRouteParams: state => state.routeParams,
    getStatusColor: (state) => code => state.statusColor[code.toUpperCase()],
    formatDate: () => (date, withTime) => {
        let format = (withTime) ? 'DD/MM/YYYY-HH:mm' : 'DD/MM/YYYY'
        if (!date) return null;
        if (isNaN(new Date(date).getTime())) {
            date = new Date(Number(date))
        }
        return moment(date).format(format);
    },
    getTheNavBarDrawer: (state) => state.theNavBarDrawer,
    getAppDistributionPoint: (state) => state.appDistributionPoint,
    getDistributionPointCatalog: (state) => state.distributionPointCatalog,
    getCalendarKey: (state) => state.calendarKey,
    getNeedToUpdateAllDashboards: (state) => state.needToUpdateAllDashboards,
};

// actions
const actions = {
    storeError({commit}, errorText) {
        commit('setError', errorText)
    },
    storeAppDistributionPoint({commit}, obj) {
        commit('setAppDistributionPoint', obj)
    },
    storeProgress({commit}, payload) {
        commit('setProgress', payload.text)
    },
    async storeLangs({commit}) {
        if (!sessionStorage.getItem('languageList')) {
            try {
                let {http} = await getApi();
                const response = await http.getData('langs');
                if (response && response.data) {
                    let langs = response.data.map(item => item.code.toLowerCase())
                    commit('setLangs', langs)
                }

            } catch (err) {
                commit('setError', err.toString())
            }
        }
    },
    async storeDistributionPointCatalog({commit}) {
        let url = `/distributionPoints`;
        let {http} = await getApi();
        const response = await http.getData(url);
        if (response && response.data) {
            commit('setDistributionPointCatalog', response.data);
        }
    },
    async storeTranslations({commit}) {
        if (!sessionStorage.getItem('translationList')) {
            try {
                let {http} = await getApi();
                const response = await http.getData('localization');
                let translationsMap = {};
                if (response && response.data) {
                    let translations = response.data;
                    translations.forEach(item => {
                        let key = `${(item.entityName) ? item.entityName : ''}${item.code}`;
                        translationsMap[key.toUpperCase() + 'RUS'] = item.rus;
                        translationsMap[key.toUpperCase() + 'ENG'] = item.eng;
                        translationsMap[key.toUpperCase() + 'KAZ'] = item.kaz;
                    })
                    commit('setTranslations', translationsMap);
                }
            } catch (err) {
                commit('setError', err.toString())
            }
        }
    },
    storeRouteName({commit}, payload) {
        commit('setRouteName', payload.item)
    },
    storeRouteParams({commit}, payload) {
        commit('setRouteParams', payload)
    },
    storeTheNavBarDrawer({commit}, payload) {
        commit('setTheNavBarDrawer', payload.value)
    },
    updateCalendarKey({commit}) {
        commit('setCalendarKey')
    },
    updateAllDashboards({commit}) {
        commit('setNeedToUpdateAllDashboards')
    },

};

// mutations
const mutations = {
    setError(state, val) {
        if (val === undefined || val === null) return;
        if (Array.isArray(val)) {
            state.errorText = val
        } else if (typeof val === 'object') {
            let obj = {type: val.errorType || 'info', value: val.errorText || val}
            if (val.meta) obj.meta = val.meta;
            state.errorText.push(obj);
        } else {
            state.errorText.push({type: 'info', value: val});
        }
    },
    setLangs(state, items) {
        state.langs = items;
        sessionStorage.removeItem('languageList');
        sessionStorage.setItem('languageList', JSON.stringify(items))
    },

    setTranslations(state, items) {
        state.translations = items;
        sessionStorage.removeItem('translationList');
        sessionStorage.setItem('translationList', JSON.stringify(items))
    },
    setProgress(state, item) {
        state.progressBar = item;
    },
    setRouteName(state, item) {
        state.routeName = item
    },
    setRouteParams(state, item) {
        state.routeParams = item
    },
    setTheNavBarDrawer(state, value) {
        state.theNavBarDrawer = value;
    },
    setAppDistributionPoint(state, value) {
        state.appDistributionPoint = value;
    },
    setDistributionPointCatalog(state, value) {
        state.distributionPointCatalog = value;
    },
    setCalendarKey(state) {
        state.calendarKey++;
    },
    setNeedToUpdateAllDashboards(state) {
        state.needToUpdateAllDashboards++;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
